<template>
  <div class="saleOverview">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @changeProject="changeProject"
      @changePerson="changePerson"
    ></SiruiSearch>

    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="true"
        :setting="false"
        :customVisible="true"
        :columns="columnListDefault"
        :rowStyle="rowStyle"
        :showFooter="1 == 1"
        :footerMethod="footerTotalCols ? footerMethodTotal : null"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnListDefault"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.field === 'isCreditsale'">{{
              transferSelectLabel(scope.row[item.field], isCreditsaleOptions)
            }}</span>
            <span v-else-if="item.field === 'ladingStatus'">{{
              transferSelectLabel(scope.row[item.field], ladingStatusOptions)
            }}</span>
            <span v-else-if="item.field === 'shippingMethod'">{{
              transferSelectLabel(scope.row[item.field], deliveryOptions)
            }}</span>
            <span v-else-if="item.field === 'deliveryMethod'">{{
              transferSelectLabel(scope.row[item.field], instructionOptions)
            }}</span>
            <span v-else-if="item.field === 'newBusinessLadingTotalAmount'">{{
              Number(scope.row[item.field]).toFixed(2)
            }}</span>
            <span v-else-if="item.field === 'accountingStatus'">{{
              transferSelectLabel(scope.row[item.field], laccountingStatusOptions)
            }}</span>
            <span v-else-if="item.field === 'shipComplete'">{{
              transferSelectLabel(scope.row[item.field], shipCompleteOptions)
            }}</span>
            <span v-else-if="item.field === 'relationLadingFlag'">{{
              transferSelectLabel(scope.row[item.field], relationLadingFlagOptions)
            }}</span>
            <span
              style="color: blue"
              @click="gotoInvoiceList(scope.row['ladingNo'])"
              v-else-if="item.field === 'nonInvoiceQuantity'"
              >{{ scope.row[item.field] | formatTableColumn(item.format) }}</span
            >
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span
              v-else-if="
                [
                  'businessChangingUnitPrice',
                  'ladingQuantity',
                  'businessLadingTotalAmount',
                  'actualSendQuantity',
                  'ladingTotalQuantity',
                ].includes(item.field)
              "
            >
              {{ replaceLastZeroStr(scope.row[item.field]) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <!-- 新增的时候选择订单商品明细dialog -->
    <creatDialog ref="creatDialog" />
    <!--批量确认 -->
    <BatchConfirmDialog ref="batchConfirmDialog" />
    <!--批量上传 -->
    <SiruiUpload
      ref="siruiUpload"
      :isShowDownTemplateBtn="true"
      @getData="getData"
      :action="action"
      :data="importData"
    />
    <!-- 打印弹框 -->
    <PrintDialog ref="printDialogRef" :apiUrl="printApi" />
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/purchaseSalesCenter/salsManage/salesLadingbill.js';
  //import BASE_API from '@/api/dataBase.js';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import SiruiUpload from '@/components/SiruiUpload';
  // import choiceType from '../../components/choiceType';
  import creatDialog from './components/creatDialog';
  import BatchConfirmDialog from '@/components/Dialog/batchConfirmDialog';
  import { filterEmpty, getUserCompanyList } from '@/common/js/util';
  import creatTransportBill from './js/creatTransportBill';
  import SALEINVOICEAPI from '@/api/financeCenter/saleInvoice.js';
  import tableMixins from '@/common/mixins/table.js';
  import XEUtils from 'xe-utils';
  export default {
    name: 'salesLadingbill',
    mixins: [tableMixins],
    components: {
      SiruiSearch,
      SiruiTable,
      // choiceType,
      SiruiUpload,
      creatDialog,
      BatchConfirmDialog,
    },
    data() {
      return {
        printApi: API.PRINT_API,
        footerTotalCols: {
          quantity: ['ladingQuantity', 'actualSendQuantity', 'nonInvoiceQuantity'],
        }, //底部合计列-字段名，数字类型（金额amount，数量quantity等）判断小数点
        query: {
          ladingNo: null,
          startGmtCreate: null,
          endGmtCreate: null,
          storageNo: null,
          deliveryMethod: null,
          contractNo: null,
          ladingCreateDate: null, //开单日期
          ladingOperatorNo: null, //操作人
          shipComplete: null, //是否完全发货
          businessInboundBatchNo: null, //业务入库批次
          startLadingCreateDate: null,
          endLadingCreateDate: null,
          //receivingUnit: undefined,
          settleBatchNo: undefined,
          startBusinessLadingTotalAmount: undefined,
          endBusinessLadingTotalAmount: undefined,
          customerNo: null,
          ladingStatus: undefined,
          startLadingTotalQuantity: undefined,
          endLadingTotalQuantity: undefined,
          supplierNo: undefined,
          shippingMethod: null,
          lastestReceiveMoneyDay: null,
          ladingBusinessCompanyCode: null,
          ladingBusinessDepartmentNo: null,
          ladingSalesmanNo: null,
          isCreditsale: null,
          deliveryDate: null,
          judgeFlag: null,
          nonInvoiceQuantity: undefined,
          supplychainName: null, //供应链主体
          identifyingCode: null, //商品识别码
          voucherNo: null,
          businessOrderNo: null,
          projectInitiationName: null, //项目简称
          settleBatchNoV2: null, //结算批次号
          personIds: [],
          personNames: '',
        },
        intDisabled: true,
        contDisabled: true,
        load: false,
        tableData: [],
        menuButtonList: [],
        multipleSelection: [],
        unitOptions: [],
        ladingStatusOptions: [],
        laccountingStatusOptions: [],
        shipCompleteOptions: [],
        relationLadingFlagOptions: [],
        instructionOptions: [], //交货方式
        deliveryOptions: [], //运输方式
        isCreditsaleOptions: [
          { value: 1, label: this.$t('salesBill.search.yes') },
          { value: 0, label: this.$t('salesBill.search.no') },
        ],
        columnListDefault: [
          {
            type: 'checkbox',
            width: '50',
            fixed: 'left',
            visible: true,
          },
          {
            field: 'settleBatchNoV2',
            title: '结算批次号',
            // width: '150',
            visible: true,
          },
          {
            field: 'contractNo',
            title: 'salesBill.table.contractNo',
            // width: '150',
            visible: true,
          },
          {
            field: 'projectInitiationName',
            title: '项目简称',
            // width: '150',
            visible: true,
          },
          {
            field: 'ladingBusinessCompanyName',
            title: 'salesBill.table.ladingBusinessCompanyName',
            // width: '150',
            visible: true,
          },
          {
            field: 'deliveryDate',
            title: 'salesBill.table.deliveryDate',
            // width: '150',
            visible: true,
          },
          {
            field: 'shippingMethod',
            title: 'salesBill.table.shippingMethod',
            // width: '150',
            visible: true,
          },
          {
            field: 'carNo',
            title: 'salesBill.table.carNo',
            // width: '150',
            visible: true,
          },
          {
            //商品描述
            field: 'productDesc',
            title: 'salesBill.table.productDesc',
            visible: true,
          },
          {
            field: 'netWeight',
            title: 'salesBill.table.netWeight',
            // width: '150',
            visible: true,
          },
          {
            field: 'deduct',
            title: 'salesBill.table.deduct',
            // width: '150',
            visible: true,
          },
          {
            field: 'businessChangingUnitPrice',
            title: '变动单价',
            // width: '150',
            visible: true,
            // format: 'formatPrice',
          },
          {
            field: 'ladingQuantity',
            title: '提单数量',
            // width: '150',
            visible: true,
            // format: 'formatQuality',
          },
          {
            field: 'businessLadingTotalAmount',
            title: '提单总金额',
            // width: '150',
            visible: true,
            // format: 'formatAmountRound',
          },
          {
            field: 'customerName',
            title: 'salesBill.table.customerName',
            // width: '150',
            visible: true,
          },

          {
            field: 'ladingNo',
            title: 'salesBill.table.ladingNo',
            // width: '150',
            visible: true,
          },

          {
            field: 'wayBillNo',
            title: '运单号',
            // width: '150',
            visible: true,
          },
          {
            field: 'ladingCreateDate',
            title: 'salesBill.table.ladingCreateDate',
            // width: '150',
            visible: true,
          },

          {
            field: 'ladingBusinessDepartmentName',
            title: 'salesBill.table.ladingBusinessDepartmentName',
            // width: '150',
            visible: true,
          },
          /* {
            field: 'isCreditsale',
            title: 'salesBill.table.isCreditsale',
            // width: '150',
            visible: true,
          }, */
          {
            field: 'lastestReceiveMoneyDay',
            title: 'salesBill.table.lastestReceiveMoneyDay',
            // width: '150',
            visible: true,
          },
          {
            field: 'storageName',
            title: 'salesBill.table.storageName',
            // width: '150',
            visible: true,
          },
          {
            field: 'ladingTotalQuantity',
            title: '提单总数量',
            // width: '150',
            visible: true,
            // format: 'formatQuality',
          },

          {
            field: 'ladingStatus',
            title: 'salesBill.table.ladingStatus',
            // width: '150',
            visible: true,
          },

          //实发数量
          {
            field: 'actualSendQuantity',
            title: '实发数量',
            // width: '150',
            visible: true,
            // format: 'formatQuality',
          },
          {
            field: 'deliveryMethod',
            title: 'salesBill.table.deliveryMethod',
            // width: '150',
            visible: true,
          },

          {
            field: 'ladingSalesmanName',
            title: 'salesBill.table.ladingSalesmanName',
            // width: '150',
            visible: true,
          },
          {
            field: 'ladingCurrencyName',
            title: 'salesBill.table.currencyName',
            // width: '150',
            visible: true,
          },
          {
            field: 'tradeTypeName',
            title: 'salesBill.table.tradeTypeName',
            // width: '150',
            visible: true,
          },
          {
            field: 'ladingOperatorName',
            title: 'salesBill.table.ladingOperatorName',
            // width: '150',
            visible: true,
          },
          {
            field: 'baseName',
            title: 'salesBill.table.baseName',
            // width: '150',
            visible: true,
          },
          {
            field: 'platformCompanyName',
            title: 'salesBill.table.platformCompanyName',
            // width: '150',
            visible: true,
          },

          {
            field: 'shipComplete',
            title: 'salesBill.table.shipComplete',
            // width: '150',
            visible: true,
          },
          {
            field: 'mark',
            title: 'salesBill.table.mark',
            // width: '150',
            visible: true,
          },
          {
            field: 'relationLadingFlag',
            title: 'salesBill.table.relationLadingFlag',
            width: '110',
            visible: true,
            fixed: 'right',
          },
          {
            field: 'relationLadingNo',
            title: 'salesBill.table.relationLadingNo',
            width: '100',
            visible: true,
            fixed: 'right',
          },
        ],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      //上传地址
      action() {
        return API.IMPORT_DATA_API;
      },
      //导入额外参数
      importData() {
        return {
          tenantCode: this.userInfo.userInfo.tenantCode,
          companyCode: this.userInfo.userInfo.companyCode,
          companyName: this.userInfo.userInfo.companyName,
          departmentCode: this.userInfo.userInfo.departmentCode,
          departmentName: this.userInfo.userInfo.departmentName,
          belongTenantCode: this.userInfo.userInfo.tenantCode,
          dataGroup: this.$globalVar.dataGroup,
          access_token: this.userInfo.userInfo.access_token,
          businessGroup: this.userInfo.userInfo.businessGroup,
        };
      },

      searchColumns() {
        return [
          {
            prop: 'personNames',
            name: '制单人',
            searchType: 'personnel',
            type: 'searchTableSpec',
            isMultiple: false,
            currentValue: this.query?.personNames ? this.query?.personNames : null,
            checkRowKeys: this.query.personIds,
            extraData: {
              personDepartmentCode: this.userInfo.userInfo.departmentCode,
            },
            changeMethod: 'changePerson',
          },
          {
            prop: 'projectInitiationName',
            name: '项目简称',
            searchType: 'projectInitiation',
            type: 'searchTableSpec',
            isMultiple: true,
            currentValue: this.query?.projectInitiationName
              ? this.query?.projectInitiationName
              : null,
            checkRowKeys: [this.query.projectInitiationNo ? this.query.projectInitiationNo : null],
            extraData: {
              projectInitiationStatusList: ['PIS04', 'PIS05', 'PIS07', 'PIS08'],
              // applyCompanyNo: this.userInfo.userInfo.companyCode,
              // applyDepartmentNo: this.userInfo.userInfo.departmentCode,
              // platformtCompany: this.userInfo.userInfo.companyCode,
              // recyclingtCompany: this.userInfo.userInfo.companyCode,

              // applyCompanyName: this.userInfo.userInfo.companyName,
              // platformtCompanyName: this.userInfo.userInfo.companyName,
              // recyclingtCompanyName: this.userInfo.userInfo.companyName,
            },
            changeMethod: 'changeProject',
          },
          {
            prop: 'settleBatchNoV2',
            name: '结算批次号',
            type: 'input',
            maxlength: 50,
          },
          {
            prop: 'ladingNo',
            name: this.$t('salesBill.search.ladingNo'),
            placeholder: this.$t('salesBill.search.ladingNoPlaceholder'),
            type: 'input',
            maxlength: 9999,
          },
          {
            prop: 'contractNo',
            name: this.$t('salesBill.search.contractNo'),
            type: 'input',
            maxlength: 30,
          },
          {
            prop: 'customerNo',
            type: 'searchTableSpec',
            name: this.$t('salesBill.search.customerNo'),
            searchType: 'customer',
            isMultiple: true,
            propCode: 'partnerCode',
            propName: 'partnerZhName',
            extraData: {
              // departmentCode: this.query.ladingBusinessDepartmentNo,
              // companyCode: this.query.ladingBusinessCompanyCode, //公司
              departmentCode: this.query.ladingBusinessDepartmentNo
                ? this.query.ladingBusinessDepartmentNo
                : this.userInfo.userInfo.departmentCode,
              companyCode: this.query.ladingBusinessCompanyCode
                ? this.query.ladingBusinessCompanyCode
                : this.userInfo.userInfo.companyCode, //公司
            },
          },
          // {
          //   prop: 'projectInitiationName',
          //   name: '项目简称',
          //   type: 'input',
          //   maxlength: 50,
          // },

          {
            prop: 'startGmtCreate',
            name: this.$t('salesBill.search.startGmtCreate'),
            type: 'startDaterangePicker',
          },
          {
            prop: 'endGmtCreate',
            name: this.$t('salesBill.search.endGmtCreate'),
            type: 'endDaterangePicker',
          },
          {
            prop: 'storageNo',
            type: 'searchTableSpec',
            name: this.$t('salesBill.search.storageNo'),
            searchType: 'warehouse',
            isMultiple: true,
            propCode: 'storageCode',
            propName: 'storageName',
          },
          /* {
            prop: 'deliveryMethod',
            name: this.$t('salesBill.search.deliveryMethod'),
            type: 'ajaxSelect',
            apiUrl: BASE_API.DIC_CREDIT_API,
            apiData: { dictType: 'sale_instruction_type' },
          },
          {
            prop: 'deliveryDate',
            name: this.$t('salesBill.search.deliveryDate'),
            type: 'date',
          }, */
          {
            prop: 'ladingStatus',
            name: this.$t('salesBill.search.ladingStatus'),
            type: 'select',
            placeholder: this.$t('salesBill.search.ladingStatusPlaceholder'),
            options: this.ladingStatusOptions,
          },
          /* {
            // 操作人
            type: 'searchTableSpec',
            name: this.$t('salesBill.search.ladingOperatorName'),
            prop: 'ladingOperatorNo',
            searchType: 'personnel',
            isMultiple: true,
            propCode: 'personNo',
            propName: 'personName',
          }, */
          {
            type: 'searchTableSpec',
            name: this.$t('salesBill.search.productDesc'),
            prop: 'productDesc',
            searchType: 'usableProduct',
            isMultiple: true,
            extraData: {
              detailProductStatus: 'ZT03',
              contractCategory: 'sales',
              adminFlag: 2,
              selectCompanyCode: '',
            },
          },
          /* {
            prop: 'receivingUnit',
            name: this.$t('salesBill.search.receivingUnit'),
            type: 'input',
            maxlength: 30,
          }, */
          /* {
            prop: 'externalContractNo',
            name: this.$t('salesBill.search.externalContractNo'),
            type: 'input',
            maxlength: 30,
            placeholder: this.$t('salePurchase.search.externalContractNoPlaceholder'),
          }, */
          /* {
            type: 'inputRange',
            prop: ['startBusinessLadingTotalAmount', 'endBusinessLadingTotalAmount'],
            precision: 6, //精度，就是保留几位小数,默认两位
            max: '99999999999999.999999',
            name: this.$t('salesBill.search.billTotalAmount'),
          }, */
          /*  {
            prop: 'shippingMethod',
            name: this.$t('salesBill.search.shippingMethod'),
            type: 'ajaxSelect',
            apiUrl: BASE_API.DIC_CREDIT_API,
            apiData: { dictType: 'delivery_method' },
          }, */
          {
            type: 'select', // 公司：操作人账户下公司
            name: this.$t('contractAgency.company'),
            prop: 'ladingBusinessCompanyCode',
            options: getUserCompanyList(),
            // changeMethod: () => {
            //   this.query.contractBusinessDepartment = "";
            // }
          },
          /* {
            type: 'inputRange',
            prop: ['startLadingTotalQuantity', 'endLadingTotalQuantity'],
            precision: 2, //精度，就是保留几位小数,默认两位
            max: 99999999999999.99,
            name: this.$t('salesBill.search.billTotalQuantity'),
          },
          {
            type: 'searchTableSpec',
            name: this.$t('salesBill.search.supplierNo'),
            prop: 'supplierNo',
            searchType: 'supplier',
            propCode: 'partnerCode',
            propName: 'partnerZhName',
            isMultiple: true,
            extraData: {
              departmentCode: this.query.ladingBusinessDepartmentNo,
              companyCode: this.query.ladingBusinessCompanyCode, //公司
            },
          },
          {
            type: 'searchTableSpec',
            name: this.$t('salesBill.search.ladingSalesmanNo'),
            prop: 'ladingSalesmanNo',
            searchType: 'personnel',
            isMultiple: true,
            propCode: 'personNo',
            propName: 'personName',
          },
          {
            // 是否完全发货
            prop: 'shipComplete',
            name: this.$t('salesBill.search.shipComplete'),
            type: 'select',
            placeholder: this.$t('salesBill.search.shipComplete'),
            options: [
              {
                label: this.$t('salesBill.search.yes'),
                value: 'Y',
              },
              {
                label: this.$t('salesBill.search.no'),
                value: 'N',
              },
            ],
          }, */
          {
            prop: 'ladingBusinessDepartmentNo',
            name: this.$t('salesBill.search.ladingBusinessDepartmentNo'),
            type: 'treeSelect',
            apiUrl: API.LIST_COMPANY_API,
            apiData: {
              tenantCode: this.userInfo.userInfo.tenantCode,
              adminFlag: this.userInfo.userInfo.adminFlag,
            },
            clearable: false,
          },
          /* {
            prop: 'lastestReceiveMoneyDay',
            name: this.$t('salesBill.search.lastestReceiveMoneyDay'),
            type: 'date',
          }, */
          {
            // 是否有关联提单
            prop: 'relationLadingFlag',
            name: this.$t('salesBill.search.relationLadingFlag'),
            type: 'select',
            placeholder: this.$t('salesBill.search.relationLadingFlag'),
            options: [
              {
                label: this.$t('salesBill.search.yes'),
                value: '1',
              },
              {
                label: this.$t('salesBill.search.no'),
                value: '0',
              },
            ],
          },
          // 关联提单号
          {
            prop: 'relationLadingNo',
            name: this.$t('salesBill.search.relationLadingNo'),
            type: 'input',
            maxlength: 30,
            placeholder: this.$t('salesBill.search.relationLadingNoPlaceholder'),
          },
        ];
      },
    },
    mounted() {
      this.$nextTick(() => {
        this.getButtonList();
        this.getDictList();
        this.getData();
      });
      this.shipCompleteOptions = [
        { value: 'Y', label: '是' },
        { value: 'N', label: '否' },
      ];
      this.relationLadingFlagOptions = [
        { value: '1', label: '是' },
        { value: '0', label: '否' },
      ];
      this.query = {
        ...this.query,
        ...{
          personIds: [this.userInfo.userInfo.userCode],
          personNames: this.userInfo.userInfo.userName,
        },
      };
    },
    methods: {
      changeProject({ val, prop }) {
        console.log(val, prop, '==');
        if (prop == 'projectInitiationName') {
          const rowData = val && Array.isArray(val) && val.length ? val[0] : {};
          this.query.projectInitiationName =
            rowData.projectAbbreviation || rowData.projectName || '';
          this.query.projectInitiationNo = rowData.projectInitiationNo || '';
        }
      },
      changePerson({ val, prop }) {
        console.log(val, prop, '==');
        if (prop == 'personNames') {
          const rowData = val && Array.isArray(val) && val.length ? val : [];
          this.query.personNames = rowData.map((item) => item.personName).join(',');
          this.query.personIds = rowData.map((item) => item.id).filter((item) => Boolean(item));
        }
      },
      //行项目样式
      rowStyle({ row }) {
        const isDuplicate = row.isDuplicate;
        if (isDuplicate) {
          return {
            backgroundColor: 'rgb(228, 120, 120)',
            color: '#fff',
          };
        }
      },
      getData() {
        const query = this.getQuery();
        // let count = Object.keys(query).length;
        // if (count == 0) {
        //   this.$message({
        //     showClose: true,
        //     message: this.$t("salePurchase.nosearchError"),
        //     type: "error"
        //   });
        //   return;
        // }
        // 分页数据
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const params = Object.assign({ pageNum, pageSize }, query);
        params.isStorageLadeDetail = 1;

        //更改为默认传null
        // params.companyCode = this.userInfo.userInfo.companyCode;
        // params.departmentCode = this.userInfo.userInfo.departmentCode;
        params.companyCode = null; // this.userInfo.userInfo.companyCode;
        params.departmentCode = null; //this.userInfo.userInfo.departmentCode;
        this.multipleSelection = [];
        this.$refs.siruiTable.clearCheckboxReserve();
        this.tableData = [];
        this.load = true;
        this.$axios.post(API.GET_DATA_API, params).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.list;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      getQuery() {
        const query = this.query;
        const result = Object.assign({}, query, {
          storageNo: query.storageNo && query.storageNo[0] ? query.storageNo[0].storageCode : '',
          // supplierNo:
          //   query.supplierNo && query.supplierNo[0]
          //     ? query.supplierNo[0].partnerCode
          //     : "",
          // customerNo:
          //   query.customerNo && query.customerNo[0]
          //     ? query.customerNo[0].partnerCode
          //     : "",
          ladingSalesmanNo:
            query.ladingSalesmanNo && query.ladingSalesmanNo[0] ? query.ladingSalesmanNo[0].id : '',
          ladingOperatorNo:
            query.ladingOperatorNo && query.ladingOperatorNo[0] ? query.ladingOperatorNo[0].id : '',
          productNo: this.handleData(query.productDesc, 'productDetailCode'), //商品描述
          supplychainNo: this.handleData(query.supplychain, 'supplierCode'), //商品描述
          customerNo: this.handleData(query.customerNo, 'partnerCode'), //客户
          supplierNo: this.handleData(query.supplierNo, 'partnerCode'), //供应商
        });
        delete result.productDesc;
        return filterEmpty(result);
      },
      //处理数据
      handleData(multipleSelection, key) {
        let selectList = multipleSelection ? multipleSelection : [];
        let list = [];
        selectList.forEach((item) => {
          if (key == 'partnerCode') {
            if (item?.allPartnerCode && item['allPartnerCode'] != undefined) {
              list.push(item?.allPartnerCode);
            } else {
              list.push(item?.partnerCode);
            }
          } else if (key == 'productDetailCode') {
            //合并的数据
            if (item.allProductDetailCode && item['allProductDetailCode'] != undefined) {
              list.push(item.allProductDetailCode);
            } else {
              list.push(item.productDetailCode);
            }
          } else if (key == 'supplierCode') {
            //合并的数据
            if (item.supplierCode && item['supplierCode'] != undefined) {
              list.push(item.supplierCode);
            } else {
              list.push(item.supplierCode);
            }
          }
        });
        return list.length != 0 ? list.join(',') : null;
      },
      // 获取字典表
      getDictList() {
        const tenantCode = this.userInfo.tenantCode; // 租户编码

        // 提单状态
        this.$axios
          .post(API.DICT_LIST, { dictType: 'sales_lading_status', tenantCode })
          .then((res) => {
            if (res.data.code === 0) {
              this.ladingStatusOptions = res.data.data;
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });
        //入账状态 notgenerate-未生成,generated-已生成未入账,posted-已入账,postError-入账失败
        this.$axios.post(API.DICT_LIST, { dictType: 'post_status', tenantCode }).then((res) => {
          if (res.data.code === 0) {
            this.laccountingStatusOptions = res.data.data;
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });

        // 交货方式
        this.$axios
          .post(API.DICT_LIST, { dictType: 'sale_instruction_type', tenantCode })
          .then((res) => {
            if (res.data.code === 0) {
              this.instructionOptions = res.data.data;
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });
        // 运输方式
        this.$axios.post(API.DICT_LIST, { dictType: 'delivery_method', tenantCode }).then((res) => {
          if (res.data.code === 0) {
            this.deliveryOptions = res.data.data;
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //下拉中文转换
      transferSelectLabel(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },

      //重置
      resetBtnClick() {
        this.query.personIds = [];
        this.query.personNames = [];
        this.query.projectInitiationName = '';
        this.query.projectInitiationNo = '';
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();

        this.getData();
        // this.$refs.siruiTable.reloadTable(this.tableData);
      },
      //点击按钮触发的方法
      chooseClick(type) {
        console.log(type, '2222');
        if (type == 'add') {
          this.$refs.creatDialog.defaultVisible = true;
        }
        if (type == 'copy') {
          this.handleCopy();
        }
        if (type == 'export') {
          this.handleExport();
        }
        if (type == 'createTransportBill') {
          this.creatTransportBill();
        }
        if (type == 'separateInvoice') {
          //单独开票
          this.separateInvoice();
        }
        if (type == 'combinedInvoice') {
          //合并1开票1
          this.combinedInvoice();
        }
        if (type == 'diffInvoice') {
          //差额开票
          this.diffInvoice();
        }
        if (type == 'delete') {
          this.batchRemove();
        }
        //手动冻结
        if (type == 'manuallyFreeze') {
          this.freezeThaw(1);
        }
        //手动解冻
        if (type == 'thawManually') {
          this.freezeThaw(2);
        }
        //批量导入
        if (type == 'importExcel') {
          this.importLading();
        }
        // 批量过账
        if (type == 'syncVoucher') {
          this.batchSyncVoucher(
            API.BATCH_VOUCHER,
            { ids: this.multipleSelection.map((it) => it.id) },
            'ids'
          );
        }
        // 批量标记过账
        if (type == 'signSyncVoucher') {
          this.batchSyncVoucher(
            API.BATCH_SIGN_VOUCHER,
            { ids: this.multipleSelection.map((it) => it.id) },
            'ids'
          );
        }
        if (type == 'doBatchConfirm') {
          this.doBatchConfirm(
            'AE_SO_MTL_RELEASE',
            { ids: this.multipleSelection.map((it) => it.id) },
            'ids'
          );
        }
        //批量确认实发数
        if (type == 'doBatchConfirmSend') {
          this.doBatchConfirmSend();
        }
        if (type == 'print') {
          // 打印
          if (this.multipleSelection.length != 1) {
            this.$message.warning('请选择一行操作');
            return;
          }
          if (this.multipleSelection[0].ladingStatus != 'TDZT07') {
            this.$message.warning('只能选择已生效的操作');
            return;
          }
          this.$refs.printDialogRef.openDialog({
            downloadOrPrint: 'print',
            ladingNo: this.multipleSelection[0].ladingNo,
          });
        }
      },

      importLading() {
        this.$refs.siruiUpload.openDialog(true, '06');
      },
      doBatchConfirmSend() {
        const selectedList = this.multipleSelection; // 选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('salesBill.message.chooseData'),
            type: 'error',
          });
          return;
        }
        for (let i = 0; i < selectedList.length; i++) {
          if (selectedList[i].ladingStatus != 'TDZT07') {
            return this.$message({
              showClose: true,
              message: `提单${selectedList[i].ladingNo}状态不为已审核通过`,
              type: 'error',
            });
          }
          if (['JHFS04', 'JHFS05', 'JHFS06'].indexOf(selectedList[i].deliveryMethod) == -1) {
            return this.$message({
              showClose: true,
              message: `提单${selectedList[i].ladingNo}为${
                this.instructionOptions.find((it) => it.value == selectedList[i].deliveryMethod)
                  .label
              }`,
              type: 'error',
            });
          }
          if (selectedList[i].shipComplete != 'N') {
            return this.$message({
              showClose: true,
              message: `提单${selectedList[i].ladingNo}已完全发货`,
              type: 'error',
            });
          }
        }
        this.$confirmAction('批量确认实发？', '是否批量确认实发？')
          .then(() => {
            let ladingNoList = {
              ladingNoList: selectedList.map((it) => it.ladingNo),
            };
            this.$axios.post(API.BATCH_UPDATE_ACTUALSENDQUANTITY, ladingNoList).then((res) => {
              if (res.data.code == 0) {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'success',
                });
                this.getNoCheckData();
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'error',
                });
                this.getNoCheckData();
              }
            });
          })
          .catch((error) => {
            this.$message({
              type: 'info',
              message: error,
            });
          });
      },

      freezeThaw(num) {
        const selectedList = this.multipleSelection; // 选中数据
        let message =
          num == 1
            ? this.$t('salesBill.message.justOnceThawManually')
            : this.$t('salesBill.message.justOnceManuallyFreeze');
        if (selectedList.length != 1) {
          this.$message({
            showClose: true,
            message: message,
            type: 'error',
          });
          return;
        }
        if (num == 1) {
          if (selectedList[0].ladingStatus != 'TDZT03') {
            this.$message({
              showClose: true,
              message: this.$t('salesBill.message.onlyApprovalThawManually'),
              type: 'error',
            });
            return;
          }
        } else {
          if (selectedList[0].ladingStatus != 'TDZT05') {
            this.$message({
              showClose: true,
              message: this.$t('salesBill.message.onlyApprovalManuallyFreeze'),
              type: 'error',
            });
            return;
          }
        }

        let api = num == 1 ? API.MANUALLY_FREEZE_API : API.THAW_MANUALLY_API;
        const params = {
          ladingNo: selectedList[0].ladingNo,
          version: selectedList[0].version,
        };
        this.$axios.post(api, params).then((res) => {
          if (0 == res.data.code) {
            this.getData();
            this.$refs.siruiTable.clearCheckboxReserve();
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'success',
            });
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      // 批量删除
      batchRemove() {
        const selectedList = this.multipleSelection; // 选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('salesBill.message.chooseData'),
            type: 'error',
          });
          return;
        }
        let ladingNo = [];
        // let ladingNoList1 = [];
        // let contractNoList1 = [];
        // 状态：只有已保存,已撤回状态可以删除
        // const notStatus = ['TDZT01', 'TDZT10'];
        for (let i = 0; i < selectedList.length; i++) {
          // if (!notStatus.includes(selectedList[i].ladingStatus)) {
          //   this.$message({
          //     showClose: true,
          //     message: this.$t('salesBill.message.onlyDeleted'),
          //     type: 'error',
          //   });
          //   return;
          // }
          // ladingNoList1.push(selectedList[i].ladingNo);
          // contractNoList1.push(selectedList[i].contractNo);
          ladingNo.push(selectedList[i].ladingNo);
        }
        this.$confirmAction()
          .then(() => {
            // let ladingNoList = {
            //   ladingNoList: JSON.parse(JSON.stringify(ladingNoList1)),
            //   contractNoList: JSON.parse(JSON.stringify(contractNoList1)),
            // };
            // let params = {
            //   ladingNo: JSON.parse(JSON.stringify(ladingNo)),
            // };
            this.$axios.post(API.DELETE_DATA_API, ladingNo).then((res) => {
              if (res.data.code == 0) {
                this.$message({
                  showClose: true,
                  message: res.data.msg || '操作成功',
                  type: 'success',
                });
                this.getData();
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'error',
                });
                this.getData();
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      handleCopy() {
        const selectedList = this.multipleSelection; // 选中数据
        if (selectedList.length != 1) {
          this.$message({
            showClose: true,
            message: this.$t('salesBill.message.justOneCopy'),
            type: 'error',
          });
          return;
        }
        const row = selectedList[0];
        this.handlePath(row.ladingNo, 'add', 'copy');
      },
      //双击事件
      dblclickEvent(value) {
        this.handlePath(value.row.ladingNo);
      },
      handleExport() {
        if (this.tableData.length === 0) {
          return this.$message({
            showClose: true,
            message: this.$t('salesBill.message.noDataExported'),
            type: 'error',
          });
        }
        const prevSelectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        const selectedList = this.multipleSelection.concat(prevSelectedList); // 选中数据
        // TODO 确认导出数据不选中是导出查询条件的，不分页
        const params = filterEmpty(this.getQuery());
        params.isStorageLadeDetail = 1;
        if (selectedList.length) {
          // 这个后端说暂时没做
          params.ladingNoList = selectedList.map((item) => {
            return item.ladingNo;
          });
        }
        this.$axios.post(API.EXPORT_LIST, params).then((res) => {
          if (res.data.code === 0) {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'success',
            });
            window.location.href = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //生成运输单
      creatTransportBill() {
        const selectedList = this.multipleSelection; // 选中数据
        if (selectedList.length != 1) {
          this.$message({
            showClose: true,
            message: this.$t('salesBill.message.justOneGenerate'),
            type: 'error',
          });
          return;
        }
        // 状态：审批驳回和已冻结和已保存的不能生成
        const notStatus = ['TDZT07'];
        const ladingStatus = selectedList[0].ladingStatus;
        if (!notStatus.includes(ladingStatus)) {
          this.$message({
            showClose: true,
            message: this.$t('salesBill.message.unableToGenerate'),
            type: 'error',
          });
          return;
        }
        let params = {
          salesLadingNo: selectedList[0].ladingNo,
        };
        this.$axios.post(API.CALC_PICK_DELIVERY, params).then((res) => {
          if (res.data.code == 0) {
            if (res.data.data == 0) {
              this.$axios
                .post(API.DETAIL_DATA_API, { ladingNo: selectedList[0].ladingNo })
                .then((res) => {
                  if (res.data.code == 0) {
                    creatTransportBill(
                      selectedList[0],
                      res.data.data.storageLadingPickingList,
                      this.userInfo,
                      res.data.data.storageLadingShippingDetailList
                    ).then((data) => {
                      if (data.data.code == 0) {
                        this.$message({
                          showClose: true,
                          message: this.$t('salesBill.message.generateSuccess'),
                          type: 'success',
                        });
                      } else {
                        this.$alert(res.data.msg);
                      }
                    });
                  }
                });
            } else {
              this.$message({
                showClose: true,
                message: this.$t('salesBill.message.transTip'),
                type: 'error',
              });
            }
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      handlePath(ladingNo, type, copy) {
        let path = {
          path:
            type == 'add'
              ? '/salePurchase/salesLadingbillAdd'
              : '/salePurchase/salesLadingbillEdit',
          name: type == 'add' ? 'salesLadingbillAdd' : 'salesLadingbillEdit',
          meta: {
            keepAlive: true,
            title:
              type == 'add'
                ? this.$t('salesBill.message.addSale')
                : this.$t('salesBill.message.editSale'),
          },
          query: { ladingNo, copy },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //单独开票
      separateInvoice() {
        const selectedList = this.multipleSelection; // 选中数据
        if (selectedList.length == 0) {
          this.$message({
            showClose: true,
            message: this.$t('salesBill.message.lessOneInvoice'),
            type: 'error',
          });
          return;
        }
        if (selectedList.find((it) => it.ladingStatus !== 'TDZT03')) {
          this.$message({
            showClose: true,
            message: this.$t('salesBill.message.onlyApprovalSeparatelyAlone'),
            type: 'error',
          });
          return;
        }
        if (selectedList.find((it) => it.accountingStatus != 'posted')) {
          this.$message({
            showClose: true,
            message: '未入账的单据不能开票',
            type: 'error',
          });
          return;
        }
        if (selectedList.find((it) => it.nonInvoiceQuantity < 0 || !it.nonInvoiceQuantity)) {
          this.$message({
            showClose: true,
            message: this.$t('salesBill.message.onlyTotalGreaterSeparately'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction('提示', this.$t('salesBill.message.sureInvoiceMsg'))
          .then(() => {
            let uniqLadingList = XEUtils.uniqObjArr(selectedList, 'ladingNo');
            if (uniqLadingList.length > 1) {
              let ladingList = uniqLadingList.map((it) => it.ladingNo);
              this.$axios
                .post(SALEINVOICEAPI.GET_INVOICE_BY_LADINGNO_ALONE, ladingList)
                .then((res) => {
                  if (res.data.code === 0) {
                    this.gotoInvoiceList(); //跳转销售开单页面
                  } else {
                    this.$alert(res.data.msg);
                  }
                });
            } else {
              this.gotoInvoice(selectedList[0].ladingNo);
            }
          })
          .catch(() => {});
      },
      //差额开票
      diffInvoice() {
        const selectedList = this.multipleSelection; // 选中数据
        if (selectedList.length == 0) {
          this.$message({
            showClose: true,
            message: this.$t('salesBill.message.lessOneInvoice'),
            type: 'error',
          });
          return;
        }
        if (selectedList.length > 1) {
          this.$message({
            showClose: true,
            message: this.$t('salesBill.message.justOneDiffInvoice'),
            type: 'error',
          });
          return;
        }
        if (selectedList.find((it) => it.ladingStatus !== 'TDZT03')) {
          this.$message({
            showClose: true,
            message: this.$t('salesBill.message.onlyApprovalSeparatelyAlone'),
            type: 'error',
          });
          return;
        }
        if (selectedList.find((it) => it.accountingStatus != 'posted')) {
          this.$message({
            showClose: true,
            message: '未入账的单据不能开票',
            type: 'error',
          });
          return;
        }
        if (!selectedList.find((it) => it.nonInvoiceQuantity == 0)) {
          this.$message({
            showClose: true,
            message: this.$t('salesBill.message.onlyTotalGreaterSeparatelyDiffInvoice'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction('提示', this.$t('salesBill.message.sureInvoiceMsg'))
          .then(() => {
            if (selectedList.length > 1) {
              let ladingList = selectedList.map((it) => it.ladingNo);
              this.$axios
                .post(SALEINVOICEAPI.GET_INVOICE_BY_LADINGNO_ALONE, ladingList)
                .then((res) => {
                  if (res.data.code === 0) {
                    this.gotoInvoiceList(); //跳转销售开单页面
                  } else {
                    this.$alert(res.data.msg);
                  }
                });
            } else {
              this.gotoInvoice(selectedList[0].ladingNo);
            }
          })
          .catch(() => {});
      },
      //跳转到开票页面
      gotoInvoiceList(ladingNo) {
        console.log(ladingNo);
        let path = {
          path: '/saleInvoice/list',
          name: 'saleInvoiceList',
          meta: {
            keepAlive: true,
            title: this.$t('salesBill.message.makeOutInvoice'),
          },
          query: { ladingNo },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //合并开票
      combinedInvoice() {
        const selectedList = this.multipleSelection; // 选中数据
        if (selectedList.length == 0) {
          this.$message({
            showClose: true,
            message: this.$t('salesBill.message.lessOneInvoice'),
            type: 'error',
          });
          return;
        }
        if (selectedList.find((it) => it.accountingStatus != 'posted')) {
          this.$message({
            showClose: true,
            message: '未入账的单据不能开票',
            type: 'error',
          });
          return;
        }
        let statusFlag = true; //默认状态都满足
        let numberFlag = true; //默认未开单总数量都满足
        let ruleFlag = true; //默认符合所有规则标记
        let ladingNoArr = [];
        let ladingNo = ''; //多个销售提单号
        selectedList.map((item) => {
          if (item.ladingStatus != 'TDZT03') {
            statusFlag = false;
          }
          if (!selectedList[0].nonInvoiceQuantity || selectedList[0].nonInvoiceQuantity < 0) {
            numberFlag = false;
          }
          if (
            item.ladingBusinessCompanyCode != selectedList[0].ladingBusinessCompanyCode ||
            item.customerNo != selectedList[0].customerNo ||
            item.ladingCurrency != selectedList[0].ladingCurrency ||
            item.tradeType != selectedList[0].tradeType
          ) {
            ruleFlag = false;
          }
          ladingNoArr.push(item.ladingNo);
        });
        if (!statusFlag) {
          this.$message({
            showClose: true,
            message: this.$t('salesBill.message.onlyApprovalSeparately'),
            type: 'error',
          });
          return;
        }
        if (!numberFlag) {
          this.$message({
            showClose: true,
            message: this.$t('salesBill.message.onlyTotalGreaterSeparately'),
            type: 'error',
          });
          return;
        }
        if (!ruleFlag) {
          this.$message({
            showClose: true,
            message: this.$t('salesBill.message.reselect'),
            type: 'error',
          });
          return;
        }
        ladingNo = ladingNoArr.join(',');
        this.$confirmAction('提示', this.$t('salesBill.message.sureInvoiceMsg'))
          .then(() => {
            this.gotoInvoice(ladingNo); //跳转销售开单页面
          })
          .catch(() => {});
      },
      //跳转到开票页面
      gotoInvoice(ladingNo) {
        let path = {
          path: '/saleInvoice/add',
          name: 'saleInvoiceAdd',
          meta: {
            keepAlive: true,
            title: this.$t('salesBill.message.makeOutInvoice'),
          },
          query: { ladingNo },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
    },
  };
</script>
